import PropTypes from 'prop-types';
import React from 'react';
import { BottomSheet } from '@guuru/react-chatwidget';
import ExpertProfile from './Profile';

const ExpertProfileSheet = function ({ chatId, partnerId }) {
  if (!chatId) {
    return null;
  }

  return (
    <BottomSheet>
      <ExpertProfile chatId={chatId} partnerId={partnerId} />
    </BottomSheet>
  );
};

ExpertProfileSheet.propTypes = {
  chatId: PropTypes.string,
};

export default ExpertProfileSheet;
